export default "__VITE_ASSET__CuOVfI1D__"